import { render, staticRenderFns } from "./Day12.vue?vue&type=template&id=2b8b1a6a"
import script from "./Day12.vue?vue&type=script&lang=js"
export * from "./Day12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports